export default () => ({
    counter: 123,
    
    // 用来存储分页信息
    pagin_info:{},
    // 用来存储首页获取到的值
    indexData:{},
    temImageLike: {},
    temLogin: null
  })